// src/store/thunks/sixCatalog/fetchSixCatalog.ts

import type { FetchSixesCatalogParams } from '@/types/SixCatalogDTOs';
import type { MappedSixesCatalogResponse } from '@/store/mappers/sixCatalog';
import { mapSixesCatalogPayloadDTOToResponse } from '@/store/mappers/sixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import {
  FILE_LIST_TOPIC,
  FILE_TRANSFER_TOPIC,
} from '@/config/networkConstants';
import { initializeP2PStackThunk } from '@/store/thunks/poc/connection/initializeP2PStackThunk';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';

export const fetchSixCatalogThunk = createAppAsyncThunk<
  MappedSixesCatalogResponse,
  FetchSixesCatalogParams | undefined
>(
  'catalog/fetchSixes',
  withLoader(
    async(params, { dispatch, extra, getState }) => {
          const { filters, search, sortField, sortDirection } = getState().sixCatalog;

      const apiResponse = await extra.sixCatalogService.fetchSixes({filters, search, sortField, sortDirection, ...params });
      const mappedResponse = mapSixesCatalogPayloadDTOToResponse(apiResponse);

      for (const six of mappedResponse.sixes) {
        const bootstrapNodes = six.bootstrapNodes
          .map((bootstrapNode) => bootstrapNode.trim())
          .filter((bootstrapNode) => bootstrapNode.length > 0);

        if (bootstrapNodes.length === 0) {
          continue;
        }

        void dispatch(
          initializeP2PStackThunk({
            sixId: six.id,
            bootstrapNodes,
            swarmKey: six.swarmKey,
            fileListTopic: FILE_LIST_TOPIC(six.id),
            fileTransferTopic: FILE_TRANSFER_TOPIC,
            autoInitializeMessaging: true,
          })
        );
      }

      if (getState().user.user?.id != null) {
        void dispatch(facilitateFileKeys());
      }

      return mappedResponse;
    }
  )
);
